var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSentimentNeutralV2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sentiment_neutral"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0003 32.667H35.0003V36.167H21.0003V32.667Z",
    fill: "#F4D06F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.167 25.667C38.1 25.667 39.667 24.1 39.667 22.167C39.667 20.234 38.1 18.667 36.167 18.667C34.234 18.667 32.667 20.234 32.667 22.167C32.667 24.1 34.234 25.667 36.167 25.667Z",
    fill: "#F4D06F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8337 25.667C21.7667 25.667 23.3337 24.1 23.3337 22.167C23.3337 20.234 21.7667 18.667 19.8337 18.667C17.9007 18.667 16.3337 20.234 16.3337 22.167C16.3337 24.1 17.9007 25.667 19.8337 25.667Z",
    fill: "#F4D06F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.977 4.66699C15.097 4.66699 4.66699 15.1203 4.66699 28.0003C4.66699 40.8803 15.097 51.3337 27.977 51.3337C40.8803 51.3337 51.3337 40.8803 51.3337 28.0003C51.3337 15.1203 40.8803 4.66699 27.977 4.66699ZM28.0003 46.667C17.687 46.667 9.33366 38.3137 9.33366 28.0003C9.33366 17.687 17.687 9.33366 28.0003 9.33366C38.3137 9.33366 46.667 17.687 46.667 28.0003C46.667 38.3137 38.3137 46.667 28.0003 46.667Z",
    fill: "#F4D06F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentimentNeutralV2);
export default __webpack_public_path__ + "static/media/sentiment_neutral_v2.607f5ea9c8375c70a68f55ed337b0e5a.svg";
export { ForwardRef as ReactComponent };